import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useSettings } from "@/context/SettingsContext";
import {
  LayoutDashboard,
  Package,
  Users,
  FileText,
  FileSpreadsheet,
  Wallet,
  HandCoins,
  Building2,
  BarChart3,
  Settings,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/products", label: "Produk & Jasa", icon: Package },
  { to: "/customers", label: "Customer", icon: Users },
  { to: "/invoices", label: "Invoice", icon: FileText },
  { to: "/quotations", label: "Penawaran", icon: FileSpreadsheet },
  { to: "/incomes", label: "Pemasukan", icon: HandCoins },
  { to: "/expenses", label: "Pengeluaran", icon: Wallet },
  { to: "/assets", label: "Asset", icon: Building2 },
  { to: "/reports", label: "Laporan", icon: BarChart3 },
  { to: "/settings", label: "Pengaturan", icon: Settings },
];

const LOGO = "https://static.prod-images.emergentagent.com/jobs/6e0fc21a-cb80-4712-b8a2-ad8db5b9866b/images/07cdcddce393b83511848cc8fe9a75a89a1af59cc01f06087a16701966566444.png";

export const SidebarContent = ({ collapsed, onNavigate }) => {
  const { settings } = useSettings();
  return (
    <div className="flex h-full flex-col">
      <div className={cn("flex h-16 items-center border-b border-border px-4", collapsed && "justify-center px-0")}>
        <img src={settings?.logo || LOGO} alt="logo" className="h-9 w-9 rounded-lg object-cover" />
        {!collapsed && (
          <span className="ml-3 truncate font-heading text-base font-extrabold tracking-tight text-foreground">
            {settings?.business_name || "BukuKas Pro"}
          </span>
        )}
      </div>
      <nav className="flex-1 space-y-1 overflow-y-auto p-3">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className={({ isActive }) =>
              cn(
                "flex items-center rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                collapsed && "justify-center px-0",
                isActive
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              )
            }
            title={collapsed ? item.label : undefined}
          >
            <item.icon className="h-5 w-5 shrink-0" strokeWidth={1.7} />
            {!collapsed && <span className="ml-3 truncate">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
      {!collapsed && (
        <div className="border-t border-border p-4">
          <p className="text-xs text-muted-foreground">BukuKas Pro v1.0</p>
        </div>
      )}
    </div>
  );
};

export default SidebarContent;
